import { createContext, useContext } from "react";

const ExpenseModalContext = createContext({});

export const useExpenseModalContext = () => useContext(ExpenseModalContext);

export default ExpenseModalContext;
